import React, { useState, useEffect } from 'react';
import Alert from 'react-bootstrap/Alert';
import filterFieldsForList from '../common/functions/filterFieldsForList';
import filterDataForList from '../common/functions/filterDataForList';
import schema from './jsonSchema';
import AdvanceList from '../common/AdvanceList';
import { useNavigate } from 'react-router-dom';
import useHeaderGenerator from '../common/functions/useHeaderGenerator';
import DirectoryService from './DirectoryService';
import { Card, Col, Row } from 'react-bootstrap';
import ColleagueCard from './ColleagueCard';

const FollowersList = () => {
  const [data, setData] = useState();
  const [columns, setColumns] = useState([]);
  const [error, setError] = useState('');
  const [noDataToShow, setNoDataToShow] = useState(true);

  useEffect(() => {
    const jsonSchema = schema;
    const fieldsForList = filterFieldsForList(jsonSchema);
    setColumns(fieldsForList);

    DirectoryService.retrieveFollowers()
      .then(followers => {
        setData(followers);
        console.log(data);
        setNoDataToShow(!followers.length > 0);
      })
      .catch(error => setError({ error: error.message }));
  }, [noDataToShow]);

  return (
    <>
      {noDataToShow && (
        <Alert key="warning" variant="warning">
          There's not any Followers to show. Let's create a new one!
        </Alert>
      )}
      {data && (
        <Card>
          <Card.Body>
            <h5>Related ({data.length})</h5>
          </Card.Body>
          <Card.Body className="">
            <Row className="gx-0 gy-1 text-center">
              {data.map(colleague => (
                <Col key={colleague.identifier} xs={6} md={4} lg={3} xxl={2}>
                  <ColleagueCard
                    colleague={colleague}
                    onDelete={identifier =>
                      setData(prev =>
                        prev.filter(f => f.identifier !== identifier)
                      )
                    }
                  />
                </Col>
              ))}
            </Row>
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default FollowersList;
